import buttonClickSound from "../../assets/static/audio/ui/button-click-12.m4a";
import { playSound, preloadSounds } from "./audio";

export function preloadButtonClickSound(): void {
    preloadSounds([buttonClickSound]);
}

export function playButtonClickSound(): void {
    // playSound(buttonClickSound, 0, [0.96, 1.04]);
    playSound(buttonClickSound, 0, [0.95, 1.05]);
}
